import {Spin} from "antd";
import {useObserver} from "mobx-react-lite";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {Container, FormContainer, MapContainer} from "./CreateDeliveryRequest.styles";
import {DeliveryRequestMap} from "./deliveryRequestMap/DeliveryRequestMap";
import {useCreateDeliveryRequest} from "./useCreateDeliveryRequest";
import {DeliveryRequestForm} from "./deliveryRequestForm/DeliveryRequestForm";

export const CreateDeliveryContext = React.createContext();
export const CreateDeliveryRequest = ({isFromCustomerTheme = false}) => {
    const [orderLoading, setOrderLoading] = useState(false);
    const deliveryRequestContext = useCreateDeliveryRequest({isFromCustomerTheme});
    const {t} = useTranslation(["newRequest"]);
    return useObserver(() => (
        <Spin
            spinning={orderLoading}
            style={{marginTop: 60, width: "100%"}}
            tip={t("newRequest.orderDataLoading", {
                ns: "newRequest"
            })}
            size="large"
        >
            <CreateDeliveryContext.Provider value={deliveryRequestContext}>
                <Container data-testid="createDeliveryRequest">
                    <FormContainer
                        xs={{span: 24, order: 2}}
                        lg={{span: 12, order: 1}}
                        xl={{span: 12, order: 1}}
                    >
                        <DeliveryRequestForm />
                    </FormContainer>
                    <MapContainer
                        xs={{span: 24, order: 1}}
                        lg={{span: 12, order: 2}}
                        xl={{span: 12, order: 2}}
                    >
                        <DeliveryRequestMap subCompanies={[]} />
                    </MapContainer>
                </Container>
            </CreateDeliveryContext.Provider>
        </Spin>
    ));
};
